import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { CartPaymentMethod } from '@ridango/components/lib/purchase/purchase.model';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-single-payment-method-v2',
    templateUrl: './single-payment-method-v2.component.html',
    styleUrls: ['./single-payment-method-v2.component.scss']
})
export class SinglePaymentMethodV2Component implements OnChanges {
    @Input() method: CartPaymentMethod;
    @Output() methodSelected = new EventEmitter<CartPaymentMethod>();

    constructor(@Inject('ENV') public env: Env) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.method && changes.method.currentValue) {
            this.methodSelectedHandler();
        }
    }

    methodSelectedHandler() {
        this.methodSelected.emit(this.method);
    }
}
